import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const BASICS_SETTINGS = 'basics settings'
export const GENDER = 'gender'
export const MALE = 'male'
export const FEMALE = 'female'
export const BOTH = 'both'
export const AGE_RANGE = 'age range'
export const MINIMUM = 'minimum'
export const MAXIMUM = 'maximum'
export const GEO = 'geo'
export const REGION = 'region'
export const STATE = 'state'
export const CITY = 'city'
export const METROPOLITAN = 'metropolitan'
export const PLACEHOLDER_MINIMUM_AGE_RANGE = 'placeholder minimum age range'
export const PLACEHOLDER_MAXIMUM_AGE_RANGE = 'placeholder maximum age range'

export default {
  [PORTUGUESE]: {
    [BASICS_SETTINGS]: 'Configurações Básicas',
    [GENDER]: 'Gênero',
    [MALE]: 'Masculino',
    [FEMALE]: 'Feminino',
    [BOTH]: 'Ambos',
    [AGE_RANGE]: 'Faixa Etária',
    [MINIMUM]: 'Mínimo',
    [MAXIMUM]: 'Máximo',
    [GEO]: 'Geografia',
    [REGION]: 'Região',
    [STATE]: 'Estado',
    [CITY]: 'Cidade',
    [METROPOLITAN]: 'Área Metropolitana',
    [PLACEHOLDER_MINIMUM_AGE_RANGE]: 'Deve ser um valor menor que o valor máximo.',
    [PLACEHOLDER_MAXIMUM_AGE_RANGE]: 'Deve ser um valor maior que o valor mínimo.',
  },

  [ENGLISH]: {
    [BASICS_SETTINGS]: 'Basic Settings',
    [GENDER]: 'Gender',
    [MALE]: 'Male',
    [FEMALE]: 'Female',
    [BOTH]: 'Both',
    [AGE_RANGE]: 'Age Range',
    [MINIMUM]: 'Minimum',
    [MAXIMUM]: 'Maximum',
    [GEO]: 'Geography',
    [REGION]: 'Region',
    [STATE]: 'State',
    [CITY]: 'City',
    [METROPOLITAN]: 'Metropolitan Area',
    [PLACEHOLDER_MINIMUM_AGE_RANGE]: 'Must be a value smaller than the maximum value.',
    [PLACEHOLDER_MAXIMUM_AGE_RANGE]: 'Must be a value bigger than the minimum value.',
  },

  [SPANISH]: {
    [BASICS_SETTINGS]: 'Ajustes Básicos',
    [GENDER]: 'Género',
    [MALE]: 'Masculino',
    [FEMALE]: 'Femenino',
    [BOTH]: 'Ambos',
    [AGE_RANGE]: 'Rango de Edad',
    [MINIMUM]: 'Mínimo',
    [MAXIMUM]: 'Máximo',
    [GEO]: 'Geografía',
    [REGION]: 'Región',
    [STATE]: 'Estado',
    [CITY]: 'Ciudad',
    [METROPOLITAN]: 'Área Metropolitana',
    [PLACEHOLDER_MINIMUM_AGE_RANGE]: 'Debe ser un valor menor que el valor máximo.',
    [PLACEHOLDER_MAXIMUM_AGE_RANGE]: 'Debe ser un valor mayor que el valor mínimo.',
  },
}
